var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { renderToString } from 'react-dom/server';
import { AtomicResultLink, AtomicResultList } from '../stencil-generated/search';
/**
 * This component serves as a wrapper for the core AtomicResultList.
 *
 * @param props
 * @returns
 */
export const ResultListWrapper = (props) => {
    const { template } = props, otherProps = __rest(props, ["template"]);
    const resultListRef = useRef(null);
    useEffect(() => {
        var _a;
        (_a = resultListRef.current) === null || _a === void 0 ? void 0 : _a.setRenderFunction((result, root, linkContainer) => {
            const templateResult = template(result);
            if (hasLinkTemplate(templateResult)) {
                createRoot(linkContainer).render(templateResult.linkTemplate);
                createRoot(root).render(templateResult.contentTemplate);
                return renderToString(templateResult.contentTemplate);
            }
            else {
                createRoot(root).render(templateResult);
                createRoot(linkContainer).render(React.createElement(AtomicResultLink, null));
                return renderToString(templateResult);
            }
        });
    }, [resultListRef]);
    return React.createElement(AtomicResultList, Object.assign({ ref: resultListRef }, otherProps));
};
const hasLinkTemplate = (template) => {
    return template.linkTemplate !== undefined;
};
//# sourceMappingURL=ResultListWrapper.js.map